var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enableTool
    ? _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("control-schooldistance", {
            attrs: {
              "data-panel": _vm.pageID,
              moduleCode: _vm.moduleCode,
              posBtnMap: _vm.mapButtons.schooldistance.position,
              idxBtnMap: _vm.mapButtons.schooldistance.order,
              showLabelBtnMap: _vm.mapButtons.schooldistance.showLabel,
              collapsible: _vm.mapButtons.schooldistance.collapsible,
              collapsed: _vm.initialCollapsedExpandCollapse,
              showButtonOnActionMap: _vm.showButtonOnActionMap,
              processDescription:
                "O percurso apresentado foi elaborado com recurso a um software de análise da rede rodoviária, que calcula a distância mais curta (em metros) entre o nº de polícia da morada de residência do aluno e o nº de polícia da morada da escola.",
              processDistanceDescripton:
                "O cálculo da distância foi efetuado considerando que o percurso é feito de carro, e considerou os sentidos de trânsito e as restrições de viragem.",
              processTitleList: "Detalhes do Percurso:",
              processError: "Ocorreu um erro a calcular a rota.",
              processEmpty:
                "Não existe nenhuma rota transitável de carro, entre os pontos seleccionados.",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }